<template>
	<div class="contentPage">
		<main-table
				v-if="factoringData"
				flag="factoring"
				pageTitle='Factoring companies'
				:headers="headers"
				:listItems="factoringData"
				:filtersList="factoringFilter"
				textCreate="Add factoring company"
				@updateClickButton="onClickButton"
				@updateEdit="onEdit"
				@updateCreate="createFactor"
				@updateSearch="onFilters"
				@updateRefreshFilters="onFilters"
				@updateChangeSort="onFilters"

				:uniqId="uniqId"
				isExport
				@updateExport="onExport"
				isSettings
				@updateSettings="onSettingsOpen"
		></main-table>
		<v-alert
				dense
				border="left"
				type="warning"
				v-if="alertShow"
		>
			You need to enter <strong>all</strong> <strong>data</strong>
		</v-alert>
		<create-factoring-new
				v-if="dialog"
				v-on:save-form="saveForm"
				:companyData="companyData"
				:permissions="permissions"
				:dialog="dialog"
				v-on:close-create="closeCreate"
		></create-factoring-new>
		<remove-block v-if="snackbar" @updateRemoveItem="onRemoveItem" @updateRemoveClose="onRemoveClose"></remove-block>
		<table-settings
				v-if="isTableSettingsDrawer"
				@updateSettingsSave="onSettingsSave"
				@updateSettingsCancel="onSettingsCancel"
				@updateSettingsClose="onSettingsClose"
				@updateSettingsAll="onSettingsAll"
				:settings="settings"
		></table-settings>
	</div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
// components
import CreateFactoringNew from '../../../components/Maintenance/Factoring/FactoringCreate/FactoringCreateNew';

const RemoveBlock = () => import("@/shared/RemoveBlock/RemoveBlock");
const TableSettings = () => import("@/shared/TableSettings/TableSettings");

// constants
import { downloadDoc } from "@/helper/getDownloadDoc";
import getUniqId from "@/helper/getUniqId";
import { getActiveSetting } from "@/helper/getActiveSetting";
import { PERMISSIONS } from "@/constants/constants";

export default {
	name: "Factoring",
	components: {
		CreateFactoringNew,
		RemoveBlock,
		TableSettings
	},
	props: {
		componentName: String,
	},
	computed: {
		...mapGetters([
			'factoringData',
			'edite',
			'factoringFilter',
			'permissions',
			'factoringExportLink',
			'factoringSettingsDefault',
			'factoringSettings',
			'factoringHeaders',
		]),
		settings() {
			return this.factoringSettings;
		},
		headers() {
			return this.factoringHeaders;
		}
	},
	watch: {
		async companyData() {
			// await this.getFactoringList();
		},
		factoringExportLink(value, oldValue) {
			if (value !== oldValue) {
				downloadDoc(value);
			}
		},
	},
	data() {
		return {
			itemRemove: null,
			snackbar: false,
			dialog: false,
			alertShow: false,
			dataAlert: { type: 'warning', message: "Please fill all data to add company" },
			companyData: {
				name: '',
				phone: '',
				city: '',
				address: '',
				fax: '',
				id: null
			},
			companyDataToSave: {},
			toCreate: false,
			edit: false,
			isTableSettingsDrawer: false,
			uniqId: null,
		};
	},
	methods: {
		...mapActions([
			'getFactoringLogs',
			'editFactoringItem',
			'getFactoringListNew',
			'setFactoringItem',
			'delFactoringItem',
			'updateFactoringItem',

			'getFactoringExport',
			'onFactoringSettingsReset',
			'onFactoringSettingsSave',
			'onFactoringSettingsAll',
		]),
		async onSettingsCancel() {
			this.onSettingsClose();
			await this.onFactoringSettingsReset();
		},
		onSettingsClose() {
			this.isTableSettingsDrawer = false;
		},
		async onSettingsSave() {
			await this.onFactoringSettingsSave();
			this.uniqId = getUniqId();
		},
		async onSettingsAll(value) {
			await this.onFactoringSettingsAll(value);
		},
		onSettingsOpen() {
			this.isTableSettingsDrawer = true;
		},
		async onExport(filters) {
			const value = filters;
			value['setting'] = getActiveSetting(this.settings);

			await this.getFactoringExport(value);
		},

		onRemoveClose() {
			this.snackbar = false;
		},
		onRemoveItem() {
			this.deleteAction();
			this.snackbar = false;
		},
		onClickButton({ key, item }) {
			if (key === "delete") {
				this.checkRemove(item);
			}
		},
		/* delete Start */
		checkRemove(item) {
			this.itemRemove = item;
			this.snackbar = true;
		},
		async deleteAction() {
			await this.delFactoringItem(this.itemRemove);
			this.snackbar = false;
			this.itemRemove = null;
		},

		/* delete End */
		async onFilters(info) {
			await this.getFactoringLogs(info);
		},

		onEdit(onValue) {
			const value = onValue.line;
			if (this.permissions[PERMISSIONS.VIEW] || this.permissions[PERMISSIONS.EDIT] || this.permissions[PERMISSIONS.BILLING]) {
				this.editFactoringItem(value.id).then(() => {
					this.companyData = {
						name: this.edite.factoring.name,
						phone: this.edite.factoring.phone,
						id: this.edite.factoring.id,
						city: this.edite.factoring.city,
						city_id: this.edite.factoring.city_id,
						address: this.edite.factoring.address,
						fax: this.edite.factoring.fax,
						zip_code: this.edite.factoring.zip_code,
						state: this.edite.factoring.state,
						state_id: this.edite.factoring.state_id,
						percent: this.edite.factoring.percent,
						payment_type: this.edite.payment_type,
						notes_rows: this.edite.notes_rows
					};
					this.toCreate = true;
					this.dialog = true;
				});
			}
		},
		createFactor() {
			this.companyData = {
				name: '',
				phonname: '',
				phone: '',
				city: '',
				city_id: '',
				address: '',
				fax: '',
				id: null,
				state: '',
				zip_code: '',
				state_id: '',
				percent: null,
				notes_rows: [],
				payment_type: []
			};
			this.toCreate = true;
			this.dialog = true;
		},
		closeCreate(value) {
			this.dialog = value;
		},
		closeFrom() {
			this.alertShow = false;
			this.companyData = {
				name: '',
				phonname: '',
				phone: '',
				city: '',
				city_id: '',
				address: '',
				fax: '',
				id: null,
				state: '',
				zip_code: '',
				state_id: '',
				percent: null,
				notes_rows: [],
				payment_type: []

			};
			this.toCreate = false;
		},
		async saveForm(value) {
			if (value.city === undefined || value.name === undefined || value.phone === undefined) {
				this.alertShow = true;
				setTimeout(() => {
					this.alertShow = false;
				}, 1500);
			} else {
				this.alertShow = false;
				const update = this.factoringData.findIndex(el => el.id === value.id);
				update != -1 ?
					await this.updateFactoringItem({
						...value,
						city: value.city.city ? value.city.city : value.city,
						city_id: value.city_id ? value.city_id : value.city.city_id
					}) :
					await this.setFactoringItem({
						...value,
						city: value.city,
						city_id: value.city_id
					});
				this.companyData = {
					name: '',
					phone: '',
					city: '',
					city_id: '',
					address: '',
					fax: '',
					id: null,
					zip_code: '',
					state: '',
				};
				// await this.getFactoringList()
				this.toCreate = false;
			}
			await this.getFactoringListNew('saveForm');
		}
	},
	async mounted() {
		await this.getFactoringListNew('mounted');
	},
	async created() {
		// await this.getFactoringList('created');
	},
};
</script>
<style lang="scss" scoped>
.title {
	margin-bottom: 15px;
}

.btn-wr {
	width: calc(50% - 16px);
}
</style>
